// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3128e639","455":"b50d6a44","977":"13b2dd04"}[chunkId] + ".chunk.js";
};